import React from 'react';

const statusConfig = {
  Draft: { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-200', label: 'Draft' },
  Submitted: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', label: 'Submitted' },
  CICForwarded: { bg: 'bg-cyan-50', text: 'text-cyan-700', border: 'border-cyan-200', label: 'CIC Forwarded' },
  AHForwarded: { bg: 'bg-indigo-50', text: 'text-indigo-700', border: 'border-indigo-200', label: 'Head Forwarded' },
  Reviewed: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', label: 'Reviewed' },
  Rejected: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', label: 'Rejected' },
  InProgress: { bg: 'bg-amber-100', text: 'text-amber-800', border: 'border-amber-200', label: 'In Progress' },
  Closed: { bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-200', label: 'Completed' },
  Completed: { bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-200', label: 'Completed' },
  Overdue: { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-200', label: 'Overdue' },
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.Draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold border ${config.bg} ${config.text} ${config.border}`}
    >
      {config.label}
    </span>
  );
}
